document.addEventListener('DOMContentLoaded', function () {
  var wrap = document.querySelector('[data-hanging-balls]');
  if (!wrap) return;
  var strings = wrap.querySelectorAll('[data-hanging-string]');
  if (!strings.length) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var MIN_LENGTH = 40;
  var MAX_LENGTH = 340;
  var MAX_SCROLL = 700;

  var ticking = false;

  function updateStrings() {
    var scrollY = window.scrollY || window.pageYOffset || 0;
    var progress = Math.min(scrollY / MAX_SCROLL, 1);
    var length = MIN_LENGTH + (MAX_LENGTH - MIN_LENGTH) * progress;
    strings.forEach(function (string) {
      string.style.setProperty('--string-length', length + 'px');
      string.style.height = length + 'px';
    });
    ticking = false;
  }

  updateStrings();

  if (prefersReducedMotion) return;

  document.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(updateStrings);
      ticking = true;
    }
  }, { passive: true });
});
